import FreemiumBannerOdeditorComponent from '@wix/thunderbolt-elements/src/components/FreemiumBanner/FreemiumBannerOdeditor/viewer/FreemiumBannerOdeditor';


const FreemiumBannerOdeditor = {
  component: FreemiumBannerOdeditorComponent
};


export const components = {
  ['FreemiumBannerOdeditor']: FreemiumBannerOdeditor
};

